"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  DISABLED: null,
  GO_TO_FORM_STEP: null,
  HTTP_LINK: null,
  FILE_DOWNLOAD: null,
  COS_PAGE_LINK: null,
  MEETINGS_LINK: null,
  CALENDAR_LINK: null
});

exports.default = _default;
module.exports = exports.default;